import {
  createTableColumn,
  TableCellLayout,
  TableColumnDefinition,
  Text,
} from "@fluentui/react-components";

import { getHighlightedText } from "../../../Controls/HighlightedText";
import { INormCollar } from "../../../Models/INormCollar";

export const getCollarColumns = (
  searchString: string,
): TableColumnDefinition<INormCollar>[] => {
  const columns = [
    createTableColumn<INormCollar>({
      columnId: "norm",
      compare: (a, b) => {
        if (a.norm && b.norm) {
          return a.norm.localeCompare(b.norm);
        } else return 0;
      },
      renderHeaderCell: () => "Norm",
      renderCell: (item) => (
        <TableCellLayout>
          <Text> {getHighlightedText(item.norm, searchString)}</Text>
        </TableCellLayout>
      ),
    }),
    createTableColumn<INormCollar>({
      columnId: "code",
      compare: (a, b) => {
        if (a.code && b.code) {
          return a.code.localeCompare(b.code);
        } else return 0;
      },
      renderHeaderCell: () => "Code",
      renderCell: (item) => <TableCellLayout>{item.code}</TableCellLayout>,
    }),
    createTableColumn<INormCollar>({
      columnId: "schluesselweite",
      compare: (a, b) => {
        if (a.schluesselweite && b.schluesselweite) {
          return (a.schluesselweite ?? 0) - (b.schluesselweite ?? 0);
        } else return 0;
      },
      renderHeaderCell: () => "Schlüsselweite",
      renderCell: (item) => (
        <TableCellLayout>{item.schluesselweite}</TableCellLayout>
      ),
    }),
    createTableColumn<INormCollar>({
      columnId: "abreiss_Drehmoment",
      compare: (a, b) => {
        if (a.abreiss_Drehmoment && b.abreiss_Drehmoment) {
          return (a.abreiss_Drehmoment ?? 0) - (b.abreiss_Drehmoment ?? 0);
        } else return 0;
      },
      renderHeaderCell: () => "Abreiß-Drehmoment",
      renderCell: (item) => (
        <TableCellLayout>{item.abreiss_Drehmoment}</TableCellLayout>
      ),
    }),
    createTableColumn<INormCollar>({
      columnId: "drehmoment_Verschraubung",
      compare: (a, b) => {
        if (a.drehmoment_Verschraubung && b.drehmoment_Verschraubung) {
          return a.drehmoment_Verschraubung.localeCompare(
            b.drehmoment_Verschraubung,
          );
        } else return 0;
      },
      renderHeaderCell: () => "Drehmoment-Verschraubung",
      renderCell: (item) => (
        <TableCellLayout>{item.drehmoment_Verschraubung}</TableCellLayout>
      ),
    }),
    createTableColumn<INormCollar>({
      columnId: "abreiss_Collar",
      compare: (a, b) => {
        if (a.abreiss_Collar && b.abreiss_Collar) {
          return a.abreiss_Collar.localeCompare(b.abreiss_Collar);
        } else return 0;
      },
      renderHeaderCell: () => "Abreiß-Collar",
      renderCell: (item) => (
        <TableCellLayout>{item.abreiss_Collar}</TableCellLayout>
      ),
    }),
    createTableColumn<INormCollar>({
      columnId: "geometrie_Collar",
      compare: (a, b) => {
        if (a.geometrie_Collar && b.geometrie_Collar) {
          return a.geometrie_Collar.localeCompare(b.geometrie_Collar);
        } else return 0;
      },
      renderHeaderCell: () => "Geometrie-Collar",
      renderCell: (item) => (
        <TableCellLayout>{item.geometrie_Collar}</TableCellLayout>
      ),
    }),
    createTableColumn<INormCollar>({
      columnId: "hI_Lite",
      compare: (a, b) => {
        if (a.hI_Lite && b.hI_Lite) {
          return a.hI_Lite.localeCompare(b.hI_Lite);
        } else return 0;
      },
      renderHeaderCell: () => "HI-Lite",
      renderCell: (item) => <TableCellLayout>{item.hI_Lite}</TableCellLayout>,
    }),
    createTableColumn<INormCollar>({
      columnId: "hI_Lock",
      compare: (a, b) => {
        if (a.hI_Lock && b.hI_Lock) {
          return a.hI_Lock.localeCompare(b.hI_Lock);
        } else return 0;
      },
      renderHeaderCell: () => "HI-Lock",
      renderCell: (item) => <TableCellLayout>{item.hI_Lock}</TableCellLayout>,
    }),
    createTableColumn<INormCollar>({
      columnId: "norm_Collar_EN",
      compare: (a, b) => {
        if (a.norm_Collar_EN && b.norm_Collar_EN) {
          return a.norm_Collar_EN.localeCompare(b.norm_Collar_EN);
        } else return 0;
      },
      renderHeaderCell: () => "Norm-Collar EN",
      renderCell: (item) => (
        <TableCellLayout>{item.norm_Collar_EN}</TableCellLayout>
      ),
    }),
    createTableColumn<INormCollar>({
      columnId: "version_Nr",
      compare: (a, b) => {
        if (a.version_Nr && b.version_Nr) {
          return a.version_Nr.localeCompare(b.version_Nr);
        } else return 0;
      },
      renderHeaderCell: () => "Versions-Nr.",
      renderCell: (item) => (
        <TableCellLayout>{item.version_Nr}</TableCellLayout>
      ),
    }),
    createTableColumn<INormCollar>({
      columnId: "version_Datum",
      compare: (a, b) => {
        if (a.version_Datum && b.version_Datum) {
          return (
            new Date(a.version_Datum ?? 0).getTime() -
            new Date(b.version_Datum ?? 0).getTime()
          );
        } else return 0;
      },
      renderHeaderCell: () => "Versions-Datum",
      renderCell: (item) => (
        <TableCellLayout>
          {item.version_Datum
            ? new Date(item.version_Datum).toLocaleDateString()
            : ""}
        </TableCellLayout>
      ),
    }),
  ];

  return columns;
};
